import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataProvider } from './contexts/DataContext';
import { Toaster } from './components/ui/sonner';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Monitoring from './pages/Monitoring';
import Providers from './pages/Providers';
import Alerts from './pages/Alerts';
import Configuration from './pages/Configuration';
import Analytics from './pages/Analytics';
import RateCalculator from './pages/RateCalculator';
import Logs from './pages/Logs';
import Skus from './pages/Skus';
import './App.css';

export const App = () => {
  return (
    <ThemeProvider>
      <DataProvider>
        <Router>
          <Layout>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/monitoring" element={<Monitoring />} />
              <Route path="/providers" element={<Providers />} />
              <Route path="/alerts" element={<Alerts />} />
              <Route path="/configuration" element={<Configuration />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/calculator" element={<RateCalculator />} />
              <Route path="/skus" element={<Skus />} />
              <Route path="/logs" element={<Logs />} />
            </Routes>
          </Layout>
        </Router>
        <Toaster position="top-right" />
      </DataProvider>
    </ThemeProvider>
  );
};

export default App;
